import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { Withdrawal } from '../../details'
import { QuestionWithdrawal } from './types'
import { transactionRequestStatus } from '../../../const'
import { withdrawalMounted } from '../../edit/model'

export const mounted = createEvent()
export const unmounted = createEvent()
export const setQuestion = createEvent<string>()
export const $question = restore<string>(setQuestion, '')
export const submitQuestion = createEvent<QuestionWithdrawal>()
export const questionTransactionRequest = fx<QuestionWithdrawal, Withdrawal>({
  method: 'PUT',
  url: `/transaction_request/`,
})

sample({
  clock: submitQuestion,
  fn: ({ requestId, rejectReason }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
        ]),
      },
      body: {
        requestId: requestId,
        status: transactionRequestStatus.questions(),
        rejectReason: rejectReason,
      },
      url: `/transaction_request/${requestId}`,
    }
  },
  target: questionTransactionRequest,
})

// clear field on success

sample({
  clock: questionTransactionRequest.done,
  fn: () => ({}),
  target: [withdrawalMounted],
})
